import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../_metronic/_partials/controls";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";

import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import { sortCaret, headerSortingClasses } from "../../_metronic/_helpers";
import { useSubheader } from "../../_metronic/layout";
import axios from "axios";
import { Link } from "react-router-dom";
import { baseURLV1 } from "../service/API.js";
import { useHistory } from "react-router-dom";

import Pagination from "@material-ui/lab/Pagination";
export const UserManangement = () => {
  const suhbeader = useSubheader();
  const { user } = useSelector((state) => state.auth);
  const [userData, setUserData] = useState([]);
  suhbeader.setTitle("User Manangement");
  const history = useHistory();
  const [table, setTable] = useState(null);
  const [rowSelect, setRowSelect] = useState([]);

  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [is_loading, setIs_Loading] = useState(false);
  const [approves, setApprove] = useState(false);

  useEffect(() => {
    getList(page,limit, "", undefined);
  }, []);

  const getList = async (page, limit, search, filters) => {
    const allData = [];
    setIs_Loading(true);

    axios({
      method: "get",
      url: `${baseURLV1}/participant?page=${page}&limit=${limit}&filters={"is_delete":false${
        filters !== undefined && filters !== "" ? `,"is_active":${filters}` : ""
      }}&searchFields=firstname,lastname,email,phone,device,distributor_name${
        search !== undefined && search !== "" ? "&search=" + search : ""
      }`,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${user.data.access_token}`,
      },
    }).then((res) => {
      console.log(res);
      res.data.data.map((data, index) => {
        data = {
          id: data.id ? data.id : "",
          email: data.email ? data.email : "",
          // firstname: data.firstname ? data.firstname : "",
          // lastname: data.lastname ? data.lastname : "",
          distributor_name: data.distributor_name ? data.distributor_name : "",
          is_active: data.is_active ? data.is_active : "",
        };
        allData.push(data);
      });

      var totalpage = Math.ceil(res.data.total / res.data.limit);
      setTotalPage(totalpage);
      setLimit(res.data.limit);
      setIs_Loading(false);
      setUserData(allData);
    });
  };

  const columns = [
    {
      dataField: "email",
      text: "Email",
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      dataField: "distributor_name",
      text: "Distributor Name",
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Approve",
      sort: true,
      sortCaret: sortCaret,
      onSort: (field, order) => {
        setApprove(!approves);
        getList(1, 10, "", !approves);
      },
      headerSortingClasses,
      formatter: (id, row, rowIndex) => {
        return <div>{row.is_active ? "true" : "false"}</div>;
      },
    },
    {
      text: "Action:",
      dataField: "id",
      formatter: (id, row, rowIndex) => {
        return (
          <div>
            {/* <button type="button" className="btn btn-primary mr-2" onClick={() => goEdit({ id, row, rowIndex })}>
              Edit
            </button> */}

            <button
              type="button"
              className="btn btn-primary"
              onClick={() => deleteItem({ row, rowIndex })}
            >
              Delete
            </button>
          </div>
        );
      },
    },
  ];

  const handleOnSelect = (row, isSelect) => {
    if (isSelect) {
      setRowSelect([
        ...rowSelect,
        {
          id: row.id,
        },
      ]);
    } else {
      let check = rowSelect.filter((x) => x.id !== row.id);
      setRowSelect(check);
    }
  };

  const handleOnSelectAll = (isSelect, rows) => {
    if (isSelect) {
      let all = [];
      rows.map((r) =>
        all.push({
          id: r.id,
        })
      );
      all.push(...rowSelect);
      setRowSelect(all);
    } else {
      let result = rowSelect.filter((row) => row.page !== page);
      setRowSelect(result);
    }
  };

  const goCreate = () => {
    history.push("/ManageUserManangement", { data: null }, { mode: "create" });
  };
  const goEdit = (data) => {
    history.push("/ManageUserManangement", data, { mode: "edit" });
  };

  const [search, setSearch] = useState();

  const handleSearch = () => {
    setPage(1);
    setLimit(limit);
    setTable(null);
    setRowSelect([]);
    getList(1, limit, search, undefined);
  };

  const handlePageChange = (event, value) => {
    setPage(value);
    getList(value, limit, search, undefined);
  };

  const handlePageSizeChange = (event) => {
    setLimit(event.target.value);
    setPage(1);
    getList(1, event.target.value, search, undefined);
  };

  const Approve = () => {
    let id = [];
    rowSelect.map((data, i) => {
      id.push(data.id);
    });
    console.log(id);

    let approve_data = {
      data: {
        is_active: true,
      },
      id: id,
    };

    axios({
      method: "POST",
      url: `${baseURLV1}/dynamic/participants/multipleUpdate`,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${user.data.access_token}`,
      },
      data: approve_data,
    })
      .then((res) => {
        Swal.fire(
          "Approve!",
          "Your user manangement has been approve.",
          "success"
        );
        getList(1, 10, "", undefined);
        setTable(null);
        setRowSelect([]);
      })
      .catch((err) => {
        Swal.fire(
          "Approve!",
          "Your user manangement has been fail to approve.",
          "error"
        );
      });
  };

  const deleteItem = (data) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You will not be able to recover this user manangement !",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it",
    }).then((result) => {
      let approve_data = {
        data: {
          is_delete: true,
        },
        id: [data.row.id],
      };

      if (result.value) {
        axios({
          method: "post",
          url: `${baseURLV1}/dynamic/participants/multipleUpdate`,
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${user.data.access_token}`,
          },
          data: approve_data,
        })
          .then((res) => {
            Swal.fire(
              "Deleted!",
              "Your user manangement has been deleted.",
              "success"
            );
            getList(1, 10, "", undefined);
            setTable(null);
            setRowSelect([]);
          })
          .catch((error) => {
            if (error.response) {
              Swal.fire("Deleted!", `${error.response.data.message}`, "error");
            }
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Cancelled", "Your user manangement is safe :)", "error");
      }
    });
  };
  return (
    <Card>
      <CardHeader title="User Manangement">
        <CardHeaderToolbar>
          {/* <Link onClick={() => goCreate()}>
            <button type="button" className="btn btn-primary">
              + Create
            </button>
          </Link> */}
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        <div class="row">
          <div className="col-md-10 form-inline mb-2">
            <div className="col-lg-4 col-md-4 col-sm-4">
              <div className="form-group">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Text Search"
                  style={{ width: "100%" }}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>
            </div>
            <div className="col-lg-2 col-md-2 col-sm-2">
              <div className="form-group">
                <button
                  type="button"
                  id="button"
                  className="btn btn-primary"
                  style={{ width: "100%" }}
                  onClick={() => handleSearch()}
                >
                  Search
                </button>
              </div>
            </div>
          </div>

          <div class="col-md-2 text-right">
            <button
              type="button"
              class="btn btn-warning ml-2"
              onClick={() => Approve()}
            >
              Approve
            </button>
          </div>
        </div>

        <div className="row">
          {is_loading ? (
            <div className="row">
              <div
                style={{
                  position: "fixed",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                }}
              >
                <div
                  className="spinner-grow text-primary spinner-grow-sm"
                  role="status"
                >
                  <span className="sr-only">Loading...</span>
                </div>
                <div
                  className="spinner-grow text-secondary spinner-grow-sm"
                  role="status"
                >
                  <span className="sr-only">Loading...</span>
                </div>
                <div
                  className="spinner-grow text-success spinner-grow-sm"
                  role="status"
                >
                  <span className="sr-only">Loading...</span>
                </div>
                <div
                  className="spinner-grow text-danger spinner-grow-sm"
                  role="status"
                >
                  <span className="sr-only">Loading...</span>
                </div>
                <div
                  className="spinner-grow text-warning spinner-grow-sm"
                  role="status"
                >
                  <span className="sr-only">Loading...</span>
                </div>
                <div
                  className="spinner-grow text-info spinner-grow-sm"
                  role="status"
                >
                  <span className="sr-only">Loading...</span>
                </div>
                <div
                  className="spinner-grow text-light spinner-grow-sm"
                  role="status"
                >
                  <span className="sr-only">Loading...</span>
                </div>
                <div
                  className="spinner-grow text-dark spinner-grow-sm"
                  role="status"
                >
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            </div>
          ) : (
            <div className="container">
              <BootstrapTable
                ref={(n) => setTable(n)}
                key="id"
                keyField="id"
                data={userData}
                columns={columns}
                selectRow={{
                  mode: "checkbox",
                  clickToSelect: true,
                  selected: rowSelect.id,
                  onSelect: handleOnSelect,
                  onSelectAll: handleOnSelectAll,
                }}
              />

              <div className=" col-lg-12">
                <div className="row">
                  <div className="col-lg-6">
                    <div className="mt-3">
                      {"Items per Page: "}
                      <select onChange={handlePageSizeChange} value={limit}>
                        <option value={5}>5</option>
                        <option value={10}>10</option>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                      </select>
                    </div>
                  </div>
                  <div
                    className="col-lg-6"
                    style={{ display: "flex", justifyContent: "flex-end" }}
                  >
                    <Pagination
                      className="mt-3 "
                      count={totalPage}
                      page={page}
                      siblingCount={1}
                      boundaryCount={1}
                      variant="outlined"
                      shape="rounded"
                      onChange={handlePageChange}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </CardBody>
    </Card>
  );
};
